<template>
<div id="messages" class="clearfix">
    <div class="" :class="modalDate === 1 ? 'motorshowapplication-region -active' : 'motorshowapplication-region'">
        <div class="motorshowapplication-title">
            <span class="title">Выберите дату и время</span>
        </div>
        <div class="motorshowapplication-form">
            <div class="application-form">
                <div class="field">
                    <input id="date" type="date" v-model="date" class="date" placeholder="__.__.____" required>
                    <input id="time" type="time" v-model="time" class="time" placeholder="__:__" required>
                    <input type="submit" class="submit" name="accept" value="ПРИНЯТЬ" @click="useLead(activeLead)">
                </div>
            </div>
        </div>
    </div>
    <div class="profilemain-region clearfix col-xs-120">
        <div class="wrapper clearfix">
            <div class="motorshow-categories">
                <button :class="params === 0 ? 'category-all categories -active' : 'category-all categories'" @click="params = 0">Новые</button>
                <button :class="params === 1 ? 'category-all categories -active' : 'category-all categories'" @click="params = 1">Ответы СТО</button>
                <button :class="params === 2 ? 'category-accepted categories -active' : 'category-accepted categories'" @click="params = 2">Принятые</button>
                <button :class="params === -2 ? 'category-accepted categories -active' : 'category-accepted categories'" @click="params = -2">Отказанные</button>
            </div>
            <div class="motorshowoffers-region col-md-120" v-for="lead in leads" :key="lead.id" v-if="params === lead.status">
                <div class="motorshowoffer-region">
                    <div class="myinformation-region">
                        <span class="myauto">Моё авто: <span class="model">{{lead.car}}</span></span>
                        <span class="offer">Услуга: <span class="content">{{lead.job}}</span></span>
                    </div>
                    <div class="motorshowoffer-main">
                        <div class="motorshowoffer-header">
                            <div class="motorshow-preview" v-if="lead.service">
                                <div class="motorshow-name">
                                    <span class="motorshowname">{{lead.service.name}}</span>
                                    <span class="motorshowlocation">{{lead.service.address}}</span>
                                </div>
                                <div class="motorshow-rate" style="display: none">
                                    <img class="motorshowrating" src="/static/img/motorshow-rating.svg">
                                </div>
                            </div>
                            <div class="motorshow-conditions" v-if="lead.status === 0">
                                <button class="motorshowchat" v-if="lead.service" type="submit" @click="showChat(lead.id,lead.ids)"><img class="icon-chat" src="/static/img/icon-envelope.svg">ЧАТ<div v-if="lead.unread !== 0 && lead.unread !== '0'" class="amount -active">{{lead.unread}}</div></button>
                            </div>
                            <div class="motorshow-conditions" v-if="lead.status === 2">
                                <span class="motorshowprice"><b>{{lead.price}} {{city.valute}}</b></span>
                                <button class="motorshowchat" type="submit" @click="showChat(lead.id,lead.ids)"><img class="icon-chat"
                                                                                 src="/static/img/icon-envelope.svg">ЧАТ<div v-if="lead.unread !== 0 && lead.unread !== '0'" class="amount -active">{{lead.unread}}</div></button>
                                <button type="button" class="motorshownumber">{{lead.service.phone}}</button>
                            </div>
                            <div class="motorshow-conditions" v-if="lead.status === -2">
                                <span class="motorshowprice"><b>{{lead.price}} {{city.valute}}</b></span>
                                <button class="motorshowchat" type="submit" @click="showChat(lead.id,lead.ids)"><img class="icon-chat"
                                                                                 src="/static/img/icon-envelope.svg">ЧАТ<div v-if="lead.unread !== 0 && lead.unread !== '0'" class="amount -active">{{lead.unread}}</div></button>
                                <button type="button" class="motorshowrefused">ОТКАЗАНО</button>
                            </div>
                            <div class="motorshow-conditions" v-if="lead.status === 1">
                                <span class="motorshowprice"><b>{{lead.price}} {{city.valute}}</b></span>
                                <button class="motorshowchat" type="submit" @click="showChat(lead.id,lead.ids)"><img class="icon-chat" src="/static/img/icon-envelope.svg">ЧАТ<div v-if="lead.unread !== 0 && lead.unread !== '0'" class="amount -active">{{lead.unread}}</div></button>
                                <button type="button" class="motorshowaccept" @click="showDate(lead.ids)">ПРИНЯТЬ</button>
                                <button type="button" class="motorshowrefuse"  @click="hideLead(lead.ids)">ОТКАЗАТЬ</button>
                            </div>
                        </div>
                        <div class="underline"></div>
                        <div class="motorshow-content">
                            <span class="motorshowcontent" v-if="lead.status === 0">ЗАЯВКА ОЖИДАЕТ РАССМОТРЕНИЯ <br>{{lead.desc}}</span>
                            <span class="motorshowcontent" v-if="lead.status !== 0">{{lead.comment}}</span>
                            <span class="motorshowcontent" v-if="lead.status === 2"><br>Дата и время записи: {{lead.date}} {{lead.time}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <chat :user.sync="user" :city.sync="city" :auth.sync="auth" :leads.sync="leads" :chat_id.sync="chat_id" :lead_id.sync="lead_id" v-if="chat_id !== 0" />
</div>
</template>

<script>
import chat from './chat'
import axios from '@/router/http'
export default {
  props: ['city', 'user', 'auth', 'leads'],
  name: 'messages',
  data () {
    return {
      params: 1,
      modalDate: 0,
      activeLead: 0,
      date: null,
      time: null,
      chat_id: 0,
      lead_id: 0
    }
  },
  components: {
    chat
  },
  created () {
  },
  methods: {
    showChat (id, ids) {
      this.chat_id = id
      this.lead_id = ids
    },
    showDate (id) {
      this.activeLead = id
      this.modalDate = 1
    },
    hideLead (id) {
      for (var key in this.leads) {
        if (this.leads[key].ids === id) {
          this.leads[key].status = -2
          axios.get('https://crm.v-avtoservice.com/list/hide-client-lead?uid=' + this.user.uid + '&lead=' + this.leads[key].ids)
        }
      }
    },
    useLead (id) {
      for (var key in this.leads) {
        if (this.leads[key].ids === id) {
          if (!this.date) alert('Укажите дату')
          else if (!this.time) alert('Укажите время')
          else {
            this.leads[key].status = 2
            this.params = 2
            this.modalDate = 0
            this.activeLead = 0
            axios.post('https://crm.v-avtoservice.com/list/use-client-lead?uid=' + this.user.uid + '&lead=' + this.leads[key].ids, JSON.stringify({
              date: this.date,
              time: this.time
            }), {crossDomain: true, headers: {'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json'}})
          }
        }
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cabinet/user/messages.vue